var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecaptchaModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00195312,
    width: 72,
    height: 72,
    rx: 13.0909,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 48.1875H45.375V52H43.5V48.1875Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9375 23.75V52H41.625V46.3125H47.25V52H52V23.75L44.4375 20L36.9375 23.75ZM47.25 27.5625H49.125V29.4375H47.25V27.5625ZM47.25 31.3125H49.125V33.1875H47.25V31.3125ZM47.25 35.0625H49.125V36.9375H47.25V35.0625ZM47.25 38.8125H49.125V40.6875H47.25V38.8125ZM47.25 42.5625H49.125V44.4375H47.25V42.5625ZM41.625 44.4375H39.75V42.5625H41.625V44.4375ZM41.625 40.6875H39.75V38.8125H41.625V40.6875ZM41.625 36.9375H39.75V35.0625H41.625V36.9375ZM41.625 33.1875H39.75V31.3125H41.625V33.1875ZM41.625 29.4375H39.75V27.5625H41.625V29.4375ZM45.375 44.4375H43.5V42.5625H45.375V44.4375ZM45.375 40.6875H43.5V38.8125H45.375V40.6875ZM45.375 36.9375H43.5V35.0625H45.375V36.9375ZM45.375 33.1875H43.5V31.3125H45.375V33.1875ZM45.375 29.4375H43.5V27.5625H45.375V29.4375Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.625 48.1875H28.5V52H26.625V48.1875Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 46.3125H30.375V52H35.0625V35.0625L27.5625 31.3125L20 35.0625V52H24.75V46.3125ZM30.375 38.8125H32.25V40.6875H30.375V38.8125ZM30.375 42.5625H32.25V44.4375H30.375V42.5625ZM26.625 38.8125H28.5V40.6875H26.625V38.8125ZM26.625 42.5625H28.5V44.4375H26.625V42.5625ZM22.875 38.8125H24.75V40.6875H22.875V38.8125ZM22.875 42.5625H24.75V44.4375H22.875V42.5625Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecaptchaModalIcon);
export default __webpack_public_path__ + "static/media/recaptcha-modal-icon.15ef5a9430056381ba4379dc4d14b351.svg";
export { ForwardRef as ReactComponent };